import {connect} from 'react-redux';

import DealReducer from './deals-reducer';
import IntraDayDeals from './intra-day-deals';
import { fetchDeals } from './deals-actions';

export const isDealActive = (deal) => {
    const currentTime = Date.now();
    const { activeDeal={} } = deal;
    const hasUnits = activeDeal.unitsLeft === -1 || activeDeal.unitsLeft > 0;
    return activeDeal.startDate <= currentTime && activeDeal.endDate > currentTime && hasUnits;
}

// Convenience component to display product price with just the product. Wire in product price catalog and user from store directly

function mapStateToProps(state, ownProps) {
    const { deals={}, userData }  = state;
    const deal = deals[ownProps.itemId];
    const { userIdle } = userData;

    return {
        productDeals: deal,
        userIdle
    }
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchDeals: (itemId, force) => dispatch(fetchDeals(itemId, force)),
        isDealActive: (deal) => isDealActive(deal)
	}
};

export { 
   DealReducer
};

export default connect(mapStateToProps, mapDispatchToProps)(IntraDayDeals);
